import PropTypes from 'prop-types';
import React from 'react';
import { Header } from 'semantic-ui-react';

import SessionDates from './SessionDates';

import WorkshopLogos from '../../../../components/workshops/WorkshopLogos';
import EntityTags from './EntityTags';

const Details = ({ session, config, registration, workshopSessions }) => {
  const { logos, title } = session;
  const { tagFields = [], logosProps, showDuration, showLocation, showSessions = true } = config;
  return (
    <>
      <WorkshopLogos logos={logos} {...logosProps} />
      <Header as="h2" className="title">
        {title}
      </Header>
      {showSessions && (
        <SessionDates
          workshopSessions={workshopSessions}
          registration={registration}
          showDuration={showDuration}
          showLocation={showLocation}
        />
      )}
      <EntityTags tagFields={tagFields} entity={session} type="workshop" />
    </>
  );
};

Details.defaultProps = {
  registration: undefined,
  workshopSessions: [],
};

Details.propTypes = {
  config: PropTypes.object.isRequired,
  registration: PropTypes.object,
  session: PropTypes.object.isRequired,
  workshopSessions: PropTypes.arrayOf(PropTypes.object),
};

export default Details;
